var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 74C57.4345 74 74 57.4345 74 37C74 16.5655 57.4345 0 37 0C16.5655 0 0 16.5655 0 37C0 57.4345 16.5655 74 37 74Z",
    fill: "#485A69"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8303 46.2106L46.8932 46.4609V61.9291L27.8459 61.7842L27.8303 46.2106Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0353 62.2572C60.578 65.9674 56.3928 68.9251 51.7413 70.9456C47.0897 72.9661 42.0715 74.0059 37.0001 74.0002C35.4642 74.0001 33.9298 73.9053 32.4056 73.7164C27.7108 73.1356 23.1722 71.6541 19.0389 69.3531C15.5196 67.3947 12.3422 64.8772 9.6308 61.8992L11.1683 58.1872L27.8423 50.7488C27.8423 56.1791 30.0455 58.1153 37.3857 58.2255C46.4501 58.3608 46.8932 56.3024 46.8932 50.7057L62.2081 58.2267L64.0353 62.2572Z",
    fill: "#D5E1ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8968 46.4334V50.5094C43.6039 56.3935 30.133 56.494 27.8303 46.2106L46.8968 46.4334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2743 10.0966C62.7565 10.0966 52.8251 52.3246 37.2743 52.3246C22.5856 52.3246 11.7921 10.0966 37.2743 10.0966Z",
    fill: "#FFE8BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9905 28.7918C18.3145 30.3964 21.4397 37.9964 23.7531 37.9616C22.7936 34.9884 22.2017 31.9089 21.9905 28.7918Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8539 28.7918C56.53 30.3952 53.4047 37.9964 51.0925 37.9616C52.0513 34.9883 52.6429 31.9088 52.8539 28.7918Z",
    fill: "#F9DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9786 35.4243C51.9786 35.4243 53.255 24.9876 49.5658 21.3523C47.9613 25.5768 40.5828 27.0197 40.5828 27.0197C42.0154 26.0176 43.3098 24.8311 44.4325 23.4909C42.4543 24.347 36.199 26.9131 30.5305 24.8811C32.0726 23.9515 33.5228 22.8774 34.8615 21.6732C34.8615 21.6732 29.7282 24.4536 24.7553 23.7591C21.1739 26.4317 22.7676 34.7298 22.7676 34.7298C17.9612 22.0528 22.3881 7.53892 37.5868 7.4551C52.3845 7.37248 56.949 21.6409 51.9774 35.4243H51.9786Z",
    fill: "#ECBE6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8459 50.5058C30.1755 53.9768 33.4958 56.6663 37.3749 58.2243L31.1699 64.6293L23.2778 52.5306L27.8459 50.5058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8908 50.5058C44.5612 53.9767 41.2408 56.6662 37.3618 58.2243L43.5656 64.6293L51.4589 52.5318L46.8908 50.5058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.953 73.8805C38.9639 73.9579 37.9645 73.9971 36.9546 73.9978C36.1931 73.9978 35.4367 73.9755 34.6855 73.9308L35.9201 63.445H38.8059L39.953 73.8805Z",
    fill: "#3DBC93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0928 61.6142L37.3701 58.2411L40.6462 61.6142L37.3701 64.9873L34.0928 61.6142Z",
    fill: "#3DBC93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6ae5d5d157c4d786fc10f0f8c4613240.svg";
export { ForwardRef as ReactComponent };